// 防抖（非立即执行）
export function debounceDelay(fn, delay = 1000) {
  let timerId;
  return function (...args) {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 防抖（立即执行）
export function debounce(fn, wait = 1000) {
  let timerId = null;
  let flag = true;
  return function () {
    clearTimeout(timerId);
    if (flag) {
      fn.apply(this, arguments);
      flag = false;
    }
    timerId = setTimeout(() => {
      flag = true;
    }, wait);
  };
}
// 节流
export function throttle(fn, wait = 1000) {
  let timerId = null;
  let canRun = true // 通过闭包保存一个标记
  return function () {
    // 在函数开头判断标记是否为 true，不为 true 则 return
    if (!canRun) return
    canRun = false // 立即设置为 false
    timerId = setTimeout(() => {
      clearTimeout(timerId);
      fn.apply(this, arguments);
      canRun = true;
    }, wait);
  };
}
